import { render, staticRenderFns } from "./ProductSkuAutocomplete.vue?vue&type=template&id=2f28b30f"
import script from "./ProductSkuAutocomplete.vue?vue&type=script&lang=ts"
export * from "./ProductSkuAutocomplete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports